import React from "react";

function WhatsWorking({ data, loading }) {
  const best = data?.best;
  const improved = data?.most_improved;
  const hasAny = best || improved;

  return (
    <div className="dv-card">
      <div className="dv-head"><div><h3>What's working</h3></div></div>
      {loading && !data ? (
        <div className="dv-empty">Loading…</div>
      ) : !hasAny ? (
        <div className="dv-empty">Not enough completion data yet to highlight a winner.</div>
      ) : (
        <>
          {best && (
            <div className="win">
              <div className="em">{best.completion_rate}%</div>
              <div>
                <div className="nm">{best.name}</div>
                <div className="cx">Best-performing path · {best.completed} of {best.started} complete</div>
              </div>
              <div className="sp" />
              <span className="st-eng"><span className="d" />Healthy</span>
            </div>
          )}
          {improved && (
            <div className="win">
              <div className="em">+{improved.delta}</div>
              <div>
                <div className="nm">{improved.name}</div>
                <div className="cx">Most improved · completion up {improved.delta} pts vs last period</div>
              </div>
              <div className="sp" />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default WhatsWorking;
